// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Hm-z","tupacHeader":"Im-z","tupacHeader2":"Jm-z","tupacMenu":"Km-z","tupacMenu2":"Lm-z","tupacMain":"Mm-z","tupacMain2":"Nm-z"};